import Vue from "vue";

export default Vue.extend({
  props: {
    value: {
      type: [Object, String],
      default: null
    },
    rules: {
      type: Array,
      default: (): any => []
    },
    validateOn: {
      type: Array,
      default: (): any => []
    }
  },

  data() {
    return {
      error: false,
      errorMessage: ""
    };
  },

  methods: {
    async validate(): Promise<boolean> {
      if (!this.rules.length) {
        return true;
      }

      const updateError = (
        error: boolean,
        message: boolean | string = ""
      ): void => {
        this.error = error;
        this.errorMessage = typeof message === "string" ? message : "";

        this.$emit("error", this.errorMessage);
      };

      const promises = [];

      for (let i = 0; i < this.rules.length; i += 1) {
        const rule = this.rules[i];
        const result = rule(this.value);

        if (result === false || typeof result === "string") {
          updateError(true, result);
          return false;
        }

        if (result !== true) {
          promises.push(result);
        }
      }

      if (!promises.length) {
        updateError(false);
        return true;
      }

      const results = await Promise.all(promises);

      for (let i = 0; i < results.length; i += 1) {
        const result = results[i];

        if (result === false || typeof result === "string") {
          updateError(true, result);
          return false;
        }
      }

      updateError(false);
      return true;
    }
  }
});
